(function () {
  angular
    .module('specsguardApp')
    .controller('BuildingAddCtrl', BuildingAddCtrl);

  BuildingAddCtrl.$inject = ['$scope', 'Auth', 'Constants', 'buildingTemplates', 'project', 'Project',
    'errorMessageService', 'buildingAddDataService', 'ProjectDataservice', 'Labels', '$state'];

  function BuildingAddCtrl ($scope, Auth, Constants, buildingTemplates, project, ProjectAPI,
    errorMessageService, buildingAddData, ProjectDataservice, Labels, $state) {

    $scope.labels = Labels;
    $scope.qualityLevels = Constants.getList('QUALITY_LEVELS');
    $scope.buildingTemplates = buildingTemplates;
    $scope.building = {};
    $scope.buildingAddData = {};
    $scope.buildingAddData = buildingAddData;
    $scope.buildingAddData.fieldsObj.buildingTemplate.options = buildingTemplates;
    $scope.buildingAddData.fieldsObj.qualityLevel.options = $scope.qualityLevels;
    $scope.buildingAddData.fieldsObj.buildingTemplate.onChange = (obj) => {
      $scope.buildingAddData.infoObj.chips = {
        label: $scope.labels.getLabel('linkedareatemplate'),
        items: obj.value,
        itemLabelKey: 'name'
      };
    };

    $scope.buildingFormSubmit = function () {
      const newBuilding = {
        _id: project._id,
        versionId: project.versionId,
        newBuilding: {
          name: $scope.building.name,
          templateId: $scope.building.buildingTemplate._id,
          qualityLevel: $scope.building.qualityLevel.value,
        }
      };

      const lastButtonIndex = $scope.buildingAddData.buttons.length - 1;
      $scope.buildingAddData.buttons[lastButtonIndex].waitingForRequest = true;

      ProjectAPI.addBuilding(newBuilding).$promise
        .then(function (obj) {
          ProjectDataservice.setProjectById(obj.project._id, obj.project);
          errorMessageService.showSuccess($scope.labels.getLabel('addbuilding'));
          $scope.buildingAddData.buttons[lastButtonIndex].waitingForRequest = false;
          $scope.building = {};
          $state.go('project/overview', {project_id: obj.project._id});
        });
    };
  }
})();
